<a (click)="goToHome()">
    <div *ngIf="id_premio == 0" class="container">
        <img src="../../assets/slot-resultados.png" alt="resultados">
        <span class="title">
            ¡FELICIDADES!
        </span>
        <span class="text">
            Ganaste un<br>10% de descuento en tus compras durante el Buen Fin.
        </span>
        <span class="text-2">
            Presiona sobre la pantalla para ir al inicio
        </span>
    </div>
    <div *ngIf="id_premio == 1" class="container">
        <img src="../../assets/slot-resultados.png" alt="resultados">
        <span class="title">
            ¡FELICIDADES!
        </span>
        <span class="text">
            Ganaste un<br>15% de descuento en tus compras en línea.
        </span>
        <span class="text-2">
            Presiona sobre la pantalla para ir al inicio
        </span>
    </div>
    <div *ngIf="id_premio == 2" class="container">
        <img src="../../assets/slot-resultados.png" alt="resultados">
        <span class="title">
            ¡FELICIDADES!
        </span>
        <span class="text">
            Ganaste un<br>cubrebocas de tela con filtro quirúrgico.
        </span>
        <span class="text-2">
            Presiona sobre la pantalla para ir al inicio
        </span>
    </div>
    <div *ngIf="id_premio == 3" class="container">
        <img src="../../assets/slot-resultados.png" alt="resultados">
        <span class="title">
            LO SENTIMOS
        </span>
        <span class="text">
            No ganaste un premio, sigue<br>participando.
        </span>
        <span class="text-2">
            Presiona sobre la pantalla para ir al inicio
        </span>
    </div>
</a>